import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { IcoMoonIcon } from '@wwe-portal/ui/components/icons';
import { cn } from '@wwe-portal/ui/lib/lib';
import { FC } from 'react';

interface RosterViewMoreButtonProps {
  onClick: () => void;
  isMore?: boolean;
}

export const RosterViewMoreButton: FC<RosterViewMoreButtonProps> = ({
  onClick,
  isMore = true,
}) => {
  return (
    <ClickableDiv
      className="drop-shadow-text flex min-w-[100px] items-center gap-1.5 text-right font-semibold italic text-[#00BAFF]"
      onClick={onClick}
    >
      <span className="drop-shadow-text-2 w-[100px]">
        {isMore ? 'VIEW MORE' : 'VIEW LESS'}
      </span>
      <IcoMoonIcon
        iconName="chevron-down"
        className={cn(
          'ml-1 h-3 w-3 rotate-0 text-white transition-all duration-500',
          {
            'rotate-180': !isMore,
          }
        )}
      />
    </ClickableDiv>
  );
};
